import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetAllProducts = (page?: number, limit?: number, exceptedIds?: string[], disabled?: boolean) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {
                if (disabled) {
                    setIsLoading(false)
                    return;
                }
                setIsLoading(true)
                if (exceptedIds) {
                    API.request()
                    .endpoint(Endpoints.cardsMnePw)
                    .url('/api/Products/GetList')
                    .get()
                    .addQuery('page', page || 1)
                    .addQuery('limit', limit || 0)
                    .addQuery('exceptTeamIds', exceptedIds)
                    .addQuery('sort', 1)
                    .addQuery('isHidden', 'false')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
                } 
                else {
                    API.request()
                    .endpoint(Endpoints.cardsMnePw)
                    .url('/api/Products/GetList')
                    .get()
                    .addQuery('page', page || 1)
                    .addQuery('limit', limit || 0)
                    .addQuery('sort', 1)
                    .addQuery('isHidden', 'false')
                    .addQuery('inStock', 'true')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
                }

        }, [page, limit, disabled])

        return [resp, isLoading, error];
    }

    export const usePaginatedProducts  = (page?: number, limit?: number, exceptedIds?: string[], disabled?: boolean) => {
        const [resp, setResp] = useState<{ data: any[], paging: any }>({ data: [], paging: null });
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
    
        useEffect(() => {

            setIsLoading(page === 1 ? true : false);
            
            const fetchData = async () => {
                try {
                    const request = API.request()
                        .endpoint(Endpoints.cardsMnePw)
                        .url('/api/Products/GetList')
                        .get()
                        .addQuery('page', page || 1)
                        .addQuery('limit', limit || 0)
                        .addQuery('sort', 1)
                        .addQuery('isHidden', 'false')
                        .addQuery('inStock', 'true');
                    
                    if (exceptedIds) {
                        request.addQuery('exceptTeamIds', exceptedIds);
                    }
    
                    const response = await request.send();
                    const data = await response.json();
    
                    setResp((prevResp) => ({
                        data: page === 1 ? data.data : [...prevResp.data, ...data.data],
                        paging: data.paging,
                    }));
                    setIsLoading(false);
                } catch (e) {
                    setIsLoading(false);
                    setError(true);
                }
            };
    
            fetchData();
        }, [page, limit, exceptedIds, disabled]);
    
        return [resp, isLoading, error];
    };import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";

export const useGetAllProducts = (page?: number, limit?: number, exceptedIds?: string[], disabled?: boolean) =>  {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);

        useEffect(() => {
                if (disabled) {
                    setIsLoading(false)
                    return;
                }
                setIsLoading(true)
                if (exceptedIds) {
                    API.request()
                    .endpoint(Endpoints.cardsMnePw)
                    .url('/api/Products/GetList')
                    .get()
                    .addQuery('page', page || 1)
                    .addQuery('limit', limit || 0)
                    .addQuery('exceptTeamIds', exceptedIds)
                    .addQuery('sort', 1)
                    .addQuery('isHidden', 'false')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
                } 
                else {
                    API.request()
                    .endpoint(Endpoints.cardsMnePw)
                    .url('/api/Products/GetList')
                    .get()
                    .addQuery('page', page || 1)
                    .addQuery('limit', limit || 0)
                    .addQuery('sort', 1)
                    .addQuery('isHidden', 'false')
                    .addQuery('inStock', 'true')
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setIsLoading(false)
                        setResp(r)
                    })
                    .catch((e) => {
                        setIsLoading(false)
                        setError(true)
                    })
                }

        }, [page, limit, disabled])

        return [resp, isLoading, error];
    }

    export const usePaginatedProducts  = (page?: number, limit?: number, exceptedIds?: string[], disabled?: boolean) => {
        const [resp, setResp] = useState<{ data: any[], paging: any }>({ data: [], paging: null });
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
    
        useEffect(() => {

            setIsLoading(page === 1 ? true : false);
            
            const fetchData = async () => {
                try {
                    const request = API.request()
                        .endpoint(Endpoints.cardsMnePw)
                        .url('/api/Products/GetList')
                        .get()
                        .addQuery('page', page || 1)
                        .addQuery('limit', limit || 0)
                        .addQuery('sort', 1)
                        .addQuery('isHidden', 'false')
                        .addQuery('inStock', 'true');
                    
                    if (exceptedIds) {
                        request.addQuery('exceptTeamIds', exceptedIds);
                    }
    
                    const response = await request.send();
                    const data = await response.json();
    
                    setResp((prevResp) => ({
                        data: page === 1 ? data.data : [...prevResp.data, ...data.data],
                        paging: data.paging,
                    }));
                    setIsLoading(false);
                } catch (e) {
                    setIsLoading(false);
                    setError(true);
                }
            };
    
            fetchData();
        }, [page, limit, exceptedIds, disabled]);
    
        return [resp, isLoading, error];
    };